module.exports = __webpack_public_path__ + "img/fullscreen_b.5e15f833.svg";